export default {
      id: "oc-dollar-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-dollar",
      toString: function () {
        return this.url;
      }
    }